import { render, staticRenderFns } from "./SButton.vue?vue&type=template&id=3b252c26&"
import script from "./SButton.vue?vue&type=script&lang=js&"
export * from "./SButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports